module.exports = __webpack_public_path__ + "img/favicon.707b0b7e.ico";